export interface IDisposable {
  dispose: () => void;
}

export function safeResource<T extends IDisposable>(resource: T, func: () => void): T {
  try {
    func();
    return resource;
  } catch (e: unknown) {
    resource.dispose();
    throw e;
  }
}

export function using<T extends IDisposable, U>(resource: T, func: (resource: T) => U): U {
  try {
    return func(resource);
  } finally {
    resource.dispose();
  }
}

export async function usingAsync<T extends IDisposable, U>(resource: T, func: (resource: T) => Promise<U>): Promise<U> {
  try {
    return await func(resource);
  } finally {
    resource.dispose();
  }
}

export function using2<T extends IDisposable, U>(resources: Array<T>, func: (...res: Array<T>) => U): U {
  try {
    return func(...resources);
  } finally {
    // disposal in reverse order
    for (let i = resources.length - 1; i >= 0; --i) {
      resources[i].dispose();
    }
  }
}
